export const GET_MAP_POSITIONS = "GET_MAP_POSITIONS";
export const GET_MAP_POSITIONS_SUCCESS = "GET_MAP_POSITIONS_SUCCESS";
export const GET_MAP_POSITIONS_ERROR = "GET_MAP_POSITIONS_ERROR";
